const GoogleRecaptchaInit = () => {
  (function () {
    if(!document.getElementById('GoogleRecaptcha')) {
      var script = document.createElement('script');
      script.setAttribute('src', '//www.google.com/recaptcha/api.js');
      script.setAttribute('type', 'application/javascript');
      script.setAttribute('id', 'GoogleRecaptcha');
      script.setAttribute('async', true);
      script.setAttribute('defer', true);
      script.addEventListener('load', function(){
        grecaptcha.ready(()=>{
          grecaptcha.render('g-recaptcha', {
            sitekey: '6LcJhLUUAAAAAF3kFpKoE1KO1vFUauc7Iw93u8Vz',
            size: 'invisible'
          });
          grecaptcha.execute();
        });
      });
      document.head.appendChild(script);
    } else {
      grecaptcha.ready(()=>{
        grecaptcha.render('g-recaptcha', {
          sitekey: '6LcJhLUUAAAAAF3kFpKoE1KO1vFUauc7Iw93u8Vz',
          size: 'invisible'
        });
        grecaptcha.execute();
      });
    }
  }());
};

export default GoogleRecaptchaInit;